import React, { useState, useEffect } from "react";
import { Card, Button, InputGroup, Form } from "react-bootstrap";
import { IconSearch, IconPlus } from "@tabler/icons-react";

const InventorySelector = ({ loadInventoryOptions, onAddItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Helper function to get BMK warehouse stock
  const getBMKWarehouseStock = (item) => {
    if (!item.warehouse_stocks || !Array.isArray(item.warehouse_stocks)) {
      return 0;
    }
    const bmkWarehouse = item.warehouse_stocks.find(
      (ws) => ws.warehouse_code === "BMK"
    );
    return bmkWarehouse ? bmkWarehouse.stock : 0;
  };

  useEffect(() => {
    loadInventory();
  }, []);

  const loadInventory = async () => {
    setLoading(true);
    setError(null);
    try {
      const options = await loadInventoryOptions(searchTerm);
      setInventoryItems(options || []);
    } catch (error) {
      console.error("Error loading inventory:", error);
      let errorMessage = "Failed to load inventory. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.error
      ) {
        errorMessage = error.response.data.error;
      } else if (error.error) {
        errorMessage = error.error;
      } else if (error.message) {
        errorMessage = error.message;
      }
      setError(errorMessage);
      setInventoryItems([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    loadInventory();
  };

  const filteredItems = inventoryItems.filter((item) =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Card>
      <Card.Header
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap",
          paddingTop: "10px",
          paddingBottom: "10px",
        }}
      >
        <h5 style={{ margin: 0, fontWeight: "600", flex: "0 0 auto" }}>
          Cari dan Pilih Item Inventory
        </h5>
        <Form onSubmit={handleSearch} style={{ flex: "1 1 280px", marginLeft: "auto" }}>
          <InputGroup>
            <Form.Control
              size="sm"
              type="text"
              placeholder="Cari inventory..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ fontSize: "14px" }}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              type="submit"
              disabled={loading}
            >
              <IconSearch size={16} />
            </Button>
          </InputGroup>
        </Form>
      </Card.Header>
      <Card.Body>
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "8px",
          }}
        >
          {loading ? (
            <p
              style={{
                textAlign: "center",
                color: "#6b7280",
                margin: "20px 0",
              }}
            >
              Memuat inventory...
            </p>
          ) : error ? (
            <p
              style={{
                textAlign: "center",
                color: "#ef4444",
                margin: "20px 0",
              }}
            >
              {error}
            </p>
          ) : filteredItems.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                color: "#6b7280",
                margin: "20px 0",
              }}
            >
              Tidak ada item inventory ditemukan
            </p>
          ) : (
            <div className="row g-2">
              {filteredItems.map((item) => (
                <div key={item.value} className="col-12 col-md-6">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      backgroundColor: "#fff",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#3b82f6";
                      e.currentTarget.style.boxShadow =
                        "0 2px 4px rgba(0,0,0,0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#e5e7eb";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                    onClick={() => onAddItem(item)}
                  >
                    <div style={{ flex: 1 }}>
                      <p
                        style={{
                          margin: 0,
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#111827",
                        }}
                      >
                        {item.item.name}
                      </p>
                      <p
                        style={{
                          margin: "4px 0 0 0",
                          fontSize: "12px",
                          color: "#6b7280",
                        }}
                      >
                        Unit: {item.item.unit} •{" "}
                        {item.item.category?.name || "No Category"} • Stock BMK:{" "}
                        {getBMKWarehouseStock(item.item)}
                      </p>
                    </div>
                    <Button
                      size="sm"
                      variant="outline-primary"
                      style={{
                        borderRadius: "50%",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                      }}
                    >
                      <IconPlus size={16} />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default InventorySelector;
